import { PropsWithChildren } from 'react';
import { Workflow } from '../../../actions/interfaces';
import { WorkflowProvider } from '../../v6/operations/settings/form/contexts/WorkflowContext';
import { PresetContextProvider } from '../../v7/contexts/PresetContext';

export const DoubleWorkflowContext = ({ value, children }: PropsWithChildren<{ value: Workflow }>) => {
  return (
    <WorkflowProvider initialWorkflow={value}>
      <PresetContextProvider initialWorkflow={value}>{children}</PresetContextProvider>
    </WorkflowProvider>
  );
};
